export const GET_SHIPMENT_DATA="GET_SHIPMENT_DATA"
export const GET_SHIPMENT_REATTEMPT_DATA="GET_SHIPMENT_REATTEMPT_DATA"
export const GET_SHIPMENT_RTO_DATA="GET_SHIPMENT_RTO_DATA"